import { z } from 'zod';

export const WorldLayoutMoveSchema = z.object({
  source: z.string().max(4096),
  target: z.string().max(4096),
  action: z.enum(['adopt', 'trash']),
  at: z.string().datetime(),
});
export type WorldLayoutMove = z.infer<typeof WorldLayoutMoveSchema>;
export const ERROR_START_REASON =
  'エラーの状態です。スナップショットから戻すか、ソフトとバージョンの変更をやり直してください';
